module.exports = __webpack_public_path__ + "static/media/wDark_thunder_rainy.576f534a.svg";